import { breadcrumbSchema } from "@/lib/schema";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { SiteLayout } from "@/components/site/Layout";
import { trackFormView } from "@/lib/analytics";
import { useGhlSubmitConfirm } from "@/lib/confirm-submission";

const FORM_ID = "16NzXd7Ac9KbnzMOlkRa";
const FORM_SRC = `https://link.agent-moves.com/widget/form/${FORM_ID}`;
const SCRIPT_SRC = "https://link.agent-moves.com/js/form_embed.js";

export const Route = createFileRoute("/strategy-call")({
  head: () => ({
    meta: [
      { title: "Growth Strategy Session - Real Estate Coaching" },
      {
        name: "description",
        content:
          "Book a 1:1 session of real estate coaching for agents with the Kristan Cole Network. Map your next 90 days and put CEO-level systems in place.",
      },
    ],
    links: [{ rel: "canonical", href: "https://joinkcn.com/strategy-call" }],
    scripts: [breadcrumbSchema([{ name: "Growth Strategy Session", path: "/strategy-call" }])],
  }),
  component: StrategyCallPage,
});

function StrategyCallPage() {
  useGhlSubmitConfirm("strategy_session", "/strategy-call");
  useEffect(() => {
    trackFormView("strategy_session", "/strategy-call");
    if (!document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
      const s = document.createElement("script");
      s.src = SCRIPT_SRC;
      s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  return (
    <SiteLayout>
      <section className="bg-background">
        <div className="container-edge pt-32 md:pt-40 pb-12">
          <p className="eyebrow text-foreground/70 mb-6">Growth Strategy Session</p>
        </div>
        <div className="container-edge">
          <div className="grid lg:grid-cols-12 gap-0">
            {/* Framing copy */}
            <div className="lg:col-span-5 bg-black text-white pr-0 md:pr-8 lg:pr-12 py-16 lg:py-24">
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
              Let's build your next 90 days.
            </h1>
            <p className="font-display italic text-2xl md:text-3xl mt-5 text-white/90 leading-snug">
              A 1:1 Growth Strategy Session with our team.
            </p>
            <div className="mt-8 space-y-5 text-white/85 text-base md:text-lg leading-relaxed">
              <p>
                This is a private working session. We'll get clear on where
                your business is right now, where you want it to go, and the
                gap between the two.
              </p>
              <p>
                Together, we'll map out your next 90 days, uncover the
                opportunities you might be missing, and put the systems in
                place so your business works for you - not the other way
                around. You'll leave with a plan you can run, whether or not
                KCN is the right fit.
              </p>
              <p className="font-display italic text-white/90">
                Complete the details and we'll reach out to schedule your session.
              </p>

            </div>
          </div>

            {/* Form */}
            <div className="lg:col-span-7 bg-black lg:pl-12">
              <iframe
                src={FORM_SRC}
                style={{ width: "100%", border: "none", display: "block" }}
                id={`inline-${FORM_ID}`}
                data-layout='{"id":"INLINE"}'
                data-trigger-type="alwaysShow"
                data-trigger-value=""
                data-activation-type="alwaysActivated"
                data-activation-value=""
                data-deactivation-type="neverDeactivate"
                data-deactivation-value=""
                data-form-name="Growth Strategy Session"
                data-height="900"
                data-layout-iframe-id={`inline-${FORM_ID}`}
                data-form-id={FORM_ID}
                title="Growth Strategy Session"
                height={1100}
                className="min-h-[1100px] w-full"
              />
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
